import { Divider, Drawer, Flex, Form } from 'antd';
import { WorkOrderField } from './work-order-field/work-order-field';
import {
  Maintenance,
  MaintenanceStatus,
} from '@/services/maintenances-service/maintenances-service.types';
import Dropdown from '../form/dropdown/dropdown';
import styles from './work-order-details-drawer.module.scss';
import { STATUS_OPTIONS } from '../maintenances-header/maintenances-header.constants';
import Label from '../form/label/label';
import { TextArea } from '../form/textarea/textarea';
import { Button } from '../button/button';

interface WorkOrderDetailsDrawerProps {
  className?: string;
  isVisible: boolean;
  onClose: () => void;
  onSubmit: (status: MaintenanceStatus, description: string) => void;
  workOrdersFields: Maintenance;
}

export function WorkOrderDetailsDrawer({
  isVisible,
  onClose,
  onSubmit,
  workOrdersFields,
}: WorkOrderDetailsDrawerProps) {
  const fieldTitles: Record<string, string> = {
    id: 'ID',
    phone: 'Phone',
    company_name: 'Company Name',
    has_property: 'Has Property',
    priority: 'Priority',
    created_at: 'Created At',
    updated_at: 'Updated At',
    yardi_id: 'Yardi ID',
    entry_notes: 'Notes',
  };

  const getTitle = (key: string): string => {
    return (
      fieldTitles[key] || key.replace(/_/g, ' ').replace(/\b\w/g, (char) => char.toUpperCase())
    );
  };

  const fieldsToDisplayInForm = ['status', 'description'];

  return (
    <Drawer
      className={styles.drawer}
      title="Work order details"
      placement="right"
      onClose={onClose}
      open={isVisible}
      width={340}
    >
      <Flex gap={3} vertical>
        {Object.entries(workOrdersFields)
          .filter(([key]) => !fieldsToDisplayInForm.includes(key))
          .filter(([key, value]) => !(key === 'yardi_id' && !value))
          .map(([key, value]) => (
            <WorkOrderField title={getTitle(key)} value={value.toString()} key={key} />
          ))}
      </Flex>

      <Divider style={{ margin: '12px 0 10px' }} />

      {/* TODO Form */}
      <Form
        className={styles.form}
        onFinish={() => {
          onSubmit(workOrdersFields.status, workOrdersFields.description);
        }}
        initialValues={{
          status: workOrdersFields.status,
          description: workOrdersFields.description,
        }}
      >
        <Flex vertical>
          <Form.Item name="status">
            <div>
              <Label text="Status" />
              <Dropdown
                data-testid="status"
                disabled
                placeholder="Status"
                options={STATUS_OPTIONS}
                value={workOrdersFields.status}
                className={styles.dropdown}
                onChange={(value) => {
                  workOrdersFields.status = value as MaintenanceStatus;
                }}
              />
            </div>
          </Form.Item>

          <Form.Item name="description">
            <div>
              <Label text="Description" />
              <TextArea
                data-testid="description"
                disabled
                placeholder="Enter description"
                value={workOrdersFields.description}
                containerClass={styles.descriptionTextAreaContainer}
                className={styles.descriptionTextArea}
                onChange={(event) => {
                  workOrdersFields.description = event.target.value;
                }}
              />
            </div>
          </Form.Item>
        </Flex>

        <Form.Item>
          <Flex gap={10} className={styles.submitButton}>
            <Button onClick={onClose} buttonVariant="secondary" className={styles.closeButton}>
              Close
            </Button>
            <Button
              className={styles.saveButton}
              buttonVariant="primary"
              htmlType="submit"
              disabled
            >
              Save
            </Button>
          </Flex>
        </Form.Item>
      </Form>
    </Drawer>
  );
}
